var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeleteicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.847 12.754l4.214 29.5h22.878l4.214-29.5H6.847zm9.031 25.285l-1.806-18.061M28.52 38.039l1.806-18.061",
    fill: "none",
    stroke: "#2d2d2d",
    strokeOpacity: 0.4,
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.072 12.754V7.336l16.254-4.215m-8.428 34.918V26.601",
    fill: "none",
    stroke: "#2d2d2d",
    strokeOpacity: 0.4,
    strokeWidth: 1.2
  })));
}

export default SvgDeleteicon;